
<script>
/* eslint-disable */
import AutoCueSlideshow from '../components/script-builder/AutoCueSlideShow.vue'

export default {
  components: {
      AutoCueSlideshow
  },
  computed: {
    currentType() {
      const url = this.$route.path;
      if (url.includes("workout")) {
        return "workouts";
      }
      if (url.includes("warmup")) {
        return "warmups";
      }
      if (url.includes("stretch-flow")) {
        return "stretchflows";
      }
      return "commons";
    },
  },
  async mounted(){
    console.log(this.currentType)
    await this.$store.dispatch(`scripts/getAutoCueWithRests`, this.$route.params.id);
    await this.$store.dispatch(`scripts/getAutoCueWithRestsAndCircuitDetails`, this.$route.params.id);
    document.onkeydown = async (evt) => {
        evt = evt || window.event;
        var isEscape = false;
        if ("key" in evt) {
            isEscape = (evt.key === "Escape" || evt.key === "Esc");
        } else {
            isEscape = (evt.keyCode === 27);
        }
        if (isEscape) {
          this.$store.commit("scripts/setActiveWorkout", this.$route.params.id);
          await this.$store.dispatch(`${this.currentType}/getActivity`, this.$route.params.id);
          await this.$store.dispatch("scripts/getCircuits", this.$route.params.id)
          await this.$store.dispatch(`scripts/getAutoCueWithRests`, this.$route.params.id);
          await this.$store.dispatch(`scripts/getAutoCueWithRestsAndCircuitDetails`, this.$route.params.id);
          this.$store.commit(`scripts/setOpened`, true);          
          this.$router.push('/update-workout/'+this.$route.params.id)
        }
    };
  }
}
</script>
<template>
    <auto-cue-slideshow :mouse-navigation="false" :repeat="true"></auto-cue-slideshow>
</template>
